import user from '@/base/model/user'

user.current_org = {}
